import React from "react";
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
import Account from "../account/content/account"

import Footer from "../../components/footer";

const index = () => {
  return (
    <section>
      <div className="main ">
        <Header />
        <InnerHeader title="My Account " />
        <Account />
        <Footer />
      </div>
    </section>
  );
};

export default index;
